import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconSnow: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M51.6668 61.2889V56.9111H48.3334V61.2889L44.1779 59.9334L43.1445 63.1111L47.3001 64.4556L44.7334 68L47.4334 69.9556L50.0001 66.4222L52.5668 69.9556L55.2668 68L52.7001 64.4556L56.8556 63.1111L55.8223 59.9334L51.6668 61.2889Z"
        fill="#D2E0FF"
      />
      <path
        d="M33.8894 70.1778V65.8H30.5561V70.1778L26.4005 68.8334L25.3672 72L29.5227 73.3445L26.9561 76.8889L29.6561 78.8445L32.2227 75.3112L34.7894 78.8445L37.4894 76.8889L34.9227 73.3445L39.0783 72L38.045 68.8334L33.8894 70.1778Z"
        fill="#D2E0FF"
      />
      <path
        d="M62.5108 81.3334L65.2108 83.2889L67.7774 79.7556L70.3441 83.2889L73.0441 81.3334L70.4774 77.7889L74.633 76.4445L73.5997 73.2778L69.4441 74.6223V70.2556H66.1108V74.6223L61.9552 73.2778L60.9219 76.4445L65.0774 77.7889L62.5108 81.3334Z"
        fill="#D2E0FF"
      />
      <path
        d="M55.8223 82.1668L51.6668 83.5112V79.1445H48.3334V83.5112L44.1779 82.1668L43.1445 85.3334L47.3001 86.6779L44.7334 90.2223L47.4334 92.1779L50.0001 88.6445L52.5668 92.1779L55.2668 90.2223L52.7001 86.6779L56.8556 85.3334L55.8223 82.1668Z"
        fill="#D2E0FF"
      />
      <path
        d="M75.4009 32.5112H70.3231V27.5778C70.3231 16.6667 61.2231 7.82227 50.0009 7.82227C40.5453 7.82227 32.6675 14.1334 30.4009 22.6334H29.6786C21.2675 22.6334 14.4453 29.2667 14.4453 37.4445C14.4453 45.6223 21.2675 52.2556 29.6786 52.2556H34.7564H65.2342H75.3898C81.0009 52.2556 85.5453 47.8334 85.5453 42.3778C85.5453 36.9223 81.012 32.5112 75.4009 32.5112Z"
        fill="#87D6F8"
      />
    </svg>
  )
}

export default WeatherIconSnow
